import { InfinityCommissionDetailItem } from "../../../../../Redux/referral/types";
import {
  formatEarningsCurrency,
  formatEarningsDate,
  statusLabel,
} from "../../earningsAdapters";

interface Props {
  data: InfinityCommissionDetailItem[];
  loading?: boolean;
}

const PrtCommDetailsTable = ({ data, loading }: Props) => {
  return (
    <div className="samriddhi-desktop-table-wrap">
      <table className="samriddhi-table samriddhi-details-table">
        <thead>
          <tr>
            <th>S.NO</th>
            <th>PURCHASER</th>
            <th>PRODUCT</th>
            <th>ORDER DETAILS</th>
            <th>LEVEL</th>
            <th>PURCHASE AMT</th>
            <th>COMMISSION</th>
            <th>TDS</th>
            <th>NET AMOUNT</th>
            <th>STATUS</th>
          </tr>
        </thead>
        <tbody>
          {loading ? (
            <tr>
              <td colSpan={10}>Loading...</td>
            </tr>
          ) : data && data.length > 0 ? (
            data.map((item, index) => (
              <tr key={item._id || index}>
                <td>
                  <strong>{index + 1}</strong>
                </td>
                <td>
                  <div className="samriddhi-contributor-info">
                    <span className="samriddhi-contributor-avatar">
                      {(item.purchaserDetails?.name || "?")
                        .charAt(0)
                        .toUpperCase()}
                    </span>
                    <div>
                      <strong>{item.purchaserDetails?.name || "—"}</strong>
                      <span>{item.registerId || ""}</span>
                      <span>{item.purchaserDetails?.email || ""}</span>
                    </div>
                  </div>
                </td>
                <td>
                  <div>
                    <strong>{item.productDetails?.productName || "—"}</strong>
                    <br />
                    <span>{item.productDetails?.productId || ""}</span>
                    <br />
                    <span>
                      {formatEarningsCurrency(
                        item.productDetails?.productPrice,
                      )}
                    </span>
                  </div>
                </td>
                <td>
                  <div>
                    <strong>{item.orderNo}</strong>
                    <br />
                    <span>{item.orderType}</span>
                    <br />
                    <span>{formatEarningsDate(item.createdAt)}</span>
                  </div>
                </td>
                <td>
                  <strong>{item.levelDistance}</strong>
                </td>
                <td>
                  <strong className="samriddhi-amount">
                    {formatEarningsCurrency(item.purchaseAmount)}
                  </strong>
                </td>
                <td>
                  <strong className="samriddhi-amount">
                    {formatEarningsCurrency(item.commissionAmount)}
                  </strong>
                </td>
                <td>
                  <strong className="samriddhi-amount">
                    {formatEarningsCurrency(item.tdsAmount)}
                    {item.tdsIsEstimated ? " (est)" : ""}
                  </strong>
                </td>
                <td>
                  <strong className="samriddhi-amount">
                    {formatEarningsCurrency(item.netAmount)}
                  </strong>
                </td>
                <td>
                  <strong>{statusLabel(item.status)}</strong>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan={10}>No details found for this period</td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default PrtCommDetailsTable;
